module.exports = __webpack_public_path__ + "static/img/background3.1cbd54a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/background3.png
// module id = X7pB
// module chunks = 13